<template>
  <v-app>
    <v-container>
      <v-card class="event.color">
        <v-card-title>{{event.name}}
        <v-spacer></v-spacer>
        <edit-calendar-event :event="event"></edit-calendar-event>
       <delete-calendar-event :event="event"></delete-calendar-event>
        <v-btn icon to="/calendar">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        </v-card-title>
      </v-card>
      <v-card>
        <v-card-text>
          <h2 class="my-4">Location: {{event.location}}</h2>
          <h2 class="my-4">Starting Date: {{event.startdate}}</h2>
          <h2 class="my-4">Starting Time: {{event.starttime}}</h2>
          <h2 class="my-4">End Date: {{event.enddate}}</h2>
          <h2 class="my-4">End Time: {{event.endtime}}</h2>
          <h2 class="my-4">Participants: {{event.participants}}</h2>
          <h2 class="my-4">Notes: {{event.notes}}</h2>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  title: 'Calendar Event',
  props: ['id'],
  computed: {
    event () {
      return this.$store.getters.loadedCalendarEvent(this.id)
    }
  }
}
</script>

<style>

</style>
